import { ContractType } from '@/utils/Enumerations'
const iconDataFor = (d, settings) => ({
  icon: d?.icon ?? settings.icon,
  tooltip: d?.tooltip ?? settings.tooltip,
  testId: d?.testId ?? settings.testId,
  value: d?.value ?? settings.value
})

const logsIconSet = (testIdPrefix, overrides) => ({
  tract: iconDataFor(overrides?.tract, {
    icon: 'mdi-crosshairs-gps',
    tooltip: 'tract',
    testId: `${testIdPrefix}-name`,
    value: contract => contract.tractName || 'N/A'
  }),
  account: iconDataFor(overrides?.account, {
    icon: 'mdi-account',
    tooltip: 'account',
    testId: `${testIdPrefix}-account`,
    value: contract => contract.accountName
  }),
  destination: iconDataFor(overrides?.destination, {
    icon: 'mdi-domain',
    tooltip: 'destination',
    testId: `${testIdPrefix}-destination`,
    value: contract => contract.destinationName
  }),
  setting: iconDataFor(overrides?.setting, {
    icon: 'mdi-map-marker-circle',
    tooltip: 'setting',
    testId: `${testIdPrefix}-setting`,
    value: contract => contract.settingName || 'N/A'
  })
})

const noTractIconSetet = (testIdPrefix, overrides) => ({
  tract: iconDataFor(overrides?.tract, {
    icon: 'mdi-account-arrow-right',
    tooltip: 'fromAccount',
    testId: `${testIdPrefix}-from-account`,
    value: contract => contract.fromAccountName || 'N/A'
  }),
  account: iconDataFor(overrides?.account, {
    icon: 'mdi-account',
    tooltip: 'account',
    testId: `${testIdPrefix}-account`,
    value: contract => contract.accountName
  }),
  destination: iconDataFor(overrides?.destination, {
    icon: 'mdi-domain',
    tooltip: 'destination',
    testId: `${testIdPrefix}-destination`,
    value: contract => contract.destinationName
  })
})

export const logsIcons = (testIdPrefix, overrides = {}) => Object.values(logsIconSet(testIdPrefix, overrides ?? {}))
export const noTractIconSet = (testIdPrefix, overrides = {}) => Object.values(noTractIconSetet(testIdPrefix, overrides ?? {}))

const settlementHeaderIcons = [
  {
    contractTypes: [ContractType.Production.value, ContractType.WoodsSale.value],
    icon: 'mdi-clipboard-outline',
    tooltip: 'logContract'
  },
  {
    contractTypes: [ContractType.ByproductSale.value, ContractType.ByproductPurchase.value, ContractType.ByproductHauling.value],
    icon: 'mdi-circular-saw',
    tooltip: 'byproductContract'
  },
  {
    contractTypes: [ContractType.Transfer.value],
    icon: 'mdi-transfer',
    tooltip: 'transferContract'
  },
  {
    contractTypes: [ContractType.LogYardSale.value],
    icon: 'mdi-truck-delivery-outline',
    tooltip: 'logYardSale'
  }
]

const contractTypeIcons = {
  [ContractType.Production.value]: { icon: 'mdi-alpha-p-circle-outline', tooltip: 'production' },
  [ContractType.WoodsSale.value]: { icon: 'mdi-alpha-w-circle-outline', tooltip: 'woodsSale' },
  [ContractType.LogYardSale.value]: { icon: 'mdi-truck-delivery-outline', tooltip: 'logYardSale' },
  [ContractType.Transfer.value]: { icon: 'mdi-transfer', tooltip: 'transferContract' }
}

export const settlementHeaderIconFor = contractType =>
  settlementHeaderIcons.find(hi => hi.contractTypes.some(ct => ct === contractType)) ?? settlementHeaderIcons[0]

export const contractTypeIconFor = contractType => contractTypeIcons[contractType]

// TODO: IH - Restore BPP Tract icon for TSBP
export const contractIconsFor = (contractType, testIdPrefix, overrides) =>
  (contractType === ContractType.ByproductSale.value ||
  contractType === ContractType.Transfer.value ||
  contractType === ContractType.ByproductPurchase.value ||
  contractType === ContractType.LogYardSale.value ||
  contractType === ContractType.ByproductHauling.value)
    ? noTractIconSet(testIdPrefix, overrides)
    : logsIcons(testIdPrefix, overrides)
